export const pivotConfigs = {
    OneDrive: {
        dataKey: "oneDriveDetail",
        fields: [
            { id: "userPrincipalName", value: "Nome do Proprietário", type: "text" },
            { id: "ownerPrincipalName", value: "E-mail do Proprietário", type: "text" },
            { id: "lastActivityDate", value: "Data da Última Atividade", type: "date", predicate: "date" },
            { id: "fileCount", value: "Arquivos", type: "text" },
            { id: "activeFileCount", value: "Arquivos Ativos", type: "text" },
            { id: "storageUsedGB", value: "GB Usados", type: "text" },
            { id: "storageAllocatedGB", value: "GB Alocados", type: "text" }
        ],
        structure: {
            rows: ["userPrincipalName", "ownerPrincipalName"],
            values: [
            { name: "fileCount", operation: ["max"] },
            { name: "activeFileCount", operation: ["max"] },
            {
                name: "storageUsedGB",
                operation: ["max"],
            },
            {
                name: "storageAllocatedGB",
                operation: ["max"],
            }
            ],
            filters: [{ name: "ownerPrincipalName" }, { name: "lastActivityDate" }]
        }
        },

    Exchange: {
        dataKey: "emailDetail",
        fields: [
            { id: "userPrincipalName", value: "Nome Principal do Usuário", type: "text" },
            { id: "displayName", value: "Nome de Exibição", type: "text" },
            { id: "isDeleted", value: "Está Deletado?", type: "boolean" },
            { id: "deletedDate", value: "Dt de Exclusão", type: "date", predicate: "date" },
            { id: "lastActivityDate", value: "Dt da Atividade", type: "date", predicate: "date" },
            { id: "receiveCount", value: "Emails Recebidos", type: "text" },
            { id: "readCount", value: "E-mails Lidos", type: "text" },
            { id: "sendCount", value: "E-mails Enviados", type: "text" },
            { id: "meetingCreatedCount", value: "Reuniões Criadas", type: "text" },
            { id: "meetingInteractedCount", value: "Reuniões Interagidas", type: "text" }
        ],
        structure: {
            rows: ["displayName", "userPrincipalName"],
            values: [
            { name: "receiveCount", operation: ["max"] },
            { name: "readCount", operation: ["max"] },
            { name: "sendCount", operation: ["max"] },
            { name: "meetingCreatedCount", operation: ["max"] },
            { name: "meetingInteractedCount", operation: ["max"] }
            ],
            filters: [{ name: "userPrincipalName" }, { name: "lastActivityDate" }]
        }
    },

    SharePoint: {
        dataKey: "sharePointDetail",
        fields: [
            { id: 'reportRefreshDate', value: "Dt de Atualização do Relatório", type: "date", predicate: "date" },
            { id: 'ownerPrincipalName', value: "E-mail do Proprietário", type: "text" },
            { id: 'lastActivityDate', value: "Data da Última Atividade", type: "date", predicate: "date" },
            { id: 'fileCount', value: "Qtd Arquivos", type: "text" },
            { id: 'activeFileCount', value: "Arquivos Ativos", type: "text" },
            { id: 'storageUsedGB', value: "GB Usados", type: "text" },
            { id: 'storageAllocatedGB', value: "GB Alocados", type: "text" },
            { id: 'visitedPageCount', value: "Qtd Visitas", type: "text" },
            { id: 'pageViewCount', value: "Qtd Páginas", type: "text" },
            { id: 'ownerDisplayName', value: "Nome de exibição", type: "text" },
            { id: 'isDeleted', value: "Está Deletado?", type: "boolean" },
            { id: 'rootWebTemplate', value: "Modelo do site raiz", type: "text" },
            { id: 'siteURL', value: "Url Site", type: "text" }
        ],
        structure: {
            rows: ["ownerPrincipalName"],
            values: [
                { name: "pageViewCount", operation: ["max"] },
                { name: "visitedPageCount", operation: ["max"] },
                { name: "fileCount", operation: ["max"] },
                { name: "activeFileCount", operation: ["max"] },
                { name: "storageUsedGB", operation: ["max"],},
                { name: "storageAllocatedGB", operation: ["max"],},
            ],
            filters: [{ name: "ownerPrincipalName" }, { name: "lastActivityDate" }]
        }
    },

    Teams: {
        dataKey: "teamsDetail",
        fields: [
            { id: 'reportRefreshDate', value: "Dt de Atualização do Relatório", type: "date", predicate: "date" },
            { id: 'userPrincipalName', value: "E-mail do Proprietário", type: "text" },
            { id: 'lastActivityDate', value: "Última Atividade", type: "text" },
            { id: 'callCount', value: "Contagem de Chamadas", type: "text" },
            { id: 'meetingCount', value: "Contagem de Meetings", type: "text" },
            { id: 'meetingsAttended', value: "Qtd Reuniões Atendidas", type: "text" },
            { id: 'meetingsOrganized', value: "Qtd Reuniões Organizadas", type: "text" },
            { id: 'postMessages', value: "Mensages Postadas", type: "text" },
            { id: 'privateChatMessages', value: "Chats Privados", type: "text" },
            { id: 'replyMessages', value: "Mensagens de resposta", type: "text" },
            { id: 'scheduledOneTimeMeetingsAttended', value: "Reuniões Agendadas Atendidas", type: "boolean" },
            { id: 'scheduledOneTimeMeetingsOrganized', value: "Reuniões Agendadas Organizadas", type: "text" },
            { id: 'scheduledRecurringMeetingsAttended', value: "Reuniões Agendadas Recorrentes Atendidas", type: "text" },
            { id: 'scheduledRecurringMeetingsOrganized', value: "Reuniões Agendadas Recorrentes Organizadas", type: "text" },
            { id: 'teamChatMessages', value: "Mensagens TeamChat", type: "text" },
            { id: 'urgentMessages', value: "Mensagens Urgentes ", type: "text" },
            { id: 'videoDurationInHours', value: "Duração vídeo", type: "text" },
            { id: 'audioDurationInHours', value: "Duração áudio", type: "text" },
            { id: 'screenShareDurationInHours', value: "Duração Compartilhamento", type: "text" }
        ],
        structure: {
            rows: ["userPrincipalName","reportRefreshDate"],
            values: [
                { name: "callCount", operation: ["max"]},
                { name: "meetingCount", operation: ["max"]},
                { name: "audioDurationInHours", operation: ["max"]},
                { name: "videoDurationInHours", operation: ["max"]},
                { name: "screenShareDurationInHours", operation: ["max"]},
            ],
            filters: [{ name: "userPrincipalName" }, { name: "lastActivityDate" }],
        }
    }
};

